export enum HttpMethod {
  UNSET_METHOD = 'UNSET_METHOD', // Do not use, needed because of proto3 limitations
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
}
